import React, { useState, useEffect, useRef } from 'react';
import './Header.css';
import whiteLogo from '../../../assets/LogoWhite.png';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [offeringsDropdownOpen, setOfferingsDropdownOpen] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0); // Track scroll position

  const dropdownRef = useRef(null);
  const offeringsDropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
      if (offeringsDropdownRef.current && !offeringsDropdownRef.current.contains(event.target)) {
        setOfferingsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    // Scroll event listener
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
    // Close all dropdowns when mobile menu toggles
    setDropdownOpen(false);
    setOfferingsDropdownOpen(false);
  };

  // Toggle company dropdown
  const toggleDropdown = (e) => {
    e.preventDefault();
    setDropdownOpen((prev) => !prev);
    setOfferingsDropdownOpen(false); // Close other dropdown
  };

  // Toggle offerings dropdown
  const toggleOfferingsDropdown = (e) => {
    e.preventDefault();
    setOfferingsDropdownOpen((prev) => !prev);
    setDropdownOpen(false); // Close other dropdown
  };

  // Close all menus when navigating via links
  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
    setDropdownOpen(false);
    setOfferingsDropdownOpen(false);
  };

  const dropdownItems = [
    { path: "/company/about", label: "About Us", description: "Our Mission and Vision", icon: "fa-solid fa-building-user" },
    { path: "/company/mission", label: "News", description: "Latest updates and insights", icon: "fas fa-newspaper" },
    { path: "/company/team", label: "Our Team", description: "Meet our team members", icon: "fas fa-users" },
    { path: "/company/history", label: "Talent Development", description: "Growth and opportunities", icon: "fas fa-chart-line" }
  ];

  const offeringsDropdownItems = [
    { path: "/offerings/ventilation", label: "Ventilation", icon: "fa-solid fa-fan" },
    { path: "/offerings/energysystem", label: "Energy Systems", icon: "fa-solid fa-solar-panel" },
    { path: "/offerings/storagesolution", label: "Storage Solutions", icon: "fa-solid fa-boxes-stacked" },
    { path: "/offerings/lightingsystem", label: "Lighting System", icon: "fa-solid fa-lightbulb" },
    { path: "/offerings/busbarsystem", label: "BusBar System", icon: "fa-solid fa-meteor" }
  ];

  return (
    <header>
      <div className="header-container">
        {/* Top Header */}
        <div className={`top-header ${scrollPosition > 50 ? 'hidden' : ''}`}>
          <div className="contact-info">
            <i className="fas fa-phone-alt"></i> +91-7448465556 &nbsp;|&nbsp;
            <i className="fas fa-envelope"></i> info@groupsui.in
          </div>
          <div className="social-icons">
            <a href="https://www.facebook.com/SSKVTECHBUILDSPRIVATELIMITED" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://x.com/Sskvtech" target="_blank" rel="noopener noreferrer">
            <i class="fa-brands fa-x-twitter"></i>
            </a>
            <a href="https://www.youtube.com/@sskvtechbuildspvt.ltd.9676" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://www.instagram.com/sskv_techbuilds/?hl=en" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.linkedin.com/company/74696864/admin/dashboard/" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin"></i>
            </a>
          </div>
        </div>

        {/* Bottom Header */}
        <div className={`bottom-header ${scrollPosition > 50 ? 'scrolled' : ''}`}>
          <div className="left-logo">
            <Link to="/">
              <img src={whiteLogo} alt="Company Logo" />
            </Link>
          </div>

          {/* Mobile menu toggle */}
          <div className={`mobile-menu-icon ${isMobileMenuOpen ? 'open' : ''}`} onClick={toggleMobileMenu}>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>

          {/* Navigation links */}
          <ul className={`header-links ${isMobileMenuOpen ? 'active' : ''}`}>
            <li>
              <a href="#" onClick={toggleDropdown}>
                Company <i className={`fas ${dropdownOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
              </a>
              {dropdownOpen && (
                <div className="dropdown-menu" ref={dropdownRef}>
                  {dropdownItems.map((item, index) => (
                    <div key={index} className="dropdown-item">
                      <Link to={item.path} onClick={handleLinkClick}>
                        <i className={item.icon} style={{ marginRight: '8px' }}></i>
                        {item.label}
                      </Link>
                      <div className="dropdown-description">{item.description}</div>
                    </div>
                  ))}
                </div>
              )}
            </li>

            <li>
              <a href="#" onClick={toggleOfferingsDropdown}>
                Offerings <i className={`fas ${offeringsDropdownOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
              </a>
              {offeringsDropdownOpen && (
                <div className="offerings-dropdown-menu" ref={offeringsDropdownRef}>
                  {offeringsDropdownItems.map((item, index) => (
                    <div key={index} className="offerings-dropdown-item">
                      <Link to={item.path} onClick={handleLinkClick}>
                        <i className={item.icon} style={{ marginRight: '8px' }}></i>
                        {item.label}
                      </Link>
                    </div>
                  ))}
                </div>
              )}
            </li>

            <li><Link to="/industries" onClick={handleLinkClick}>Industries</Link></li>
            <li><Link to="/career" onClick={handleLinkClick}>Careers</Link></li>
            <li><Link to="/contacts" onClick={handleLinkClick}>Contact Us</Link></li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
